export enum PermInterviewDateSubStatusEnum {
    Scheduled = 11,
    CompletedPendingDecision = 12
}
